import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

const AUTH_TIMEOUT_MS = 8000;

const Index = () => {
  const { user, loading } = useAuth();
  const [showTimeoutError, setShowTimeoutError] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowTimeoutError(false);
      return;
    }
    const timer = setTimeout(() => {
      if (loading) setShowTimeoutError(true);
    }, AUTH_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  if (showTimeoutError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-4 p-6">
          <p className="text-destructive font-medium">Session verification timed out.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm hover:bg-primary/90"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="space-y-4 w-64 text-center">
          <Skeleton className="h-10 w-10 rounded-full mx-auto" />
          <Skeleton className="h-4 w-48 mx-auto" />
          <p className="text-sm text-muted-foreground">Verifying session…</p>
        </div>
      </div>
    );
  }

  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
};

export default Index;
